import { render, staticRenderFns } from "./usCommodityCode.vue?vue&type=template&id=6547381e&scoped=true&"
import script from "./usCommodityCode.vue?vue&type=script&lang=js&"
export * from "./usCommodityCode.vue?vue&type=script&lang=js&"
import style0 from "./usCommodityCode.vue?vue&type=style&index=0&id=6547381e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6547381e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6547381e')) {
      api.createRecord('6547381e', component.options)
    } else {
      api.reload('6547381e', component.options)
    }
    module.hot.accept("./usCommodityCode.vue?vue&type=template&id=6547381e&scoped=true&", function () {
      api.rerender('6547381e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/usCommodityCode.vue"
export default component.exports